const gsap = window.gsap;

if (gsap !== undefined) {
  // Section title
  gsap.from(".section_cta .section-title", {
    autoAlpha: 0,
    opacity: 0,
    y: 25,
    duration: 1,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section_cta",
      start: "top 80%",
    },
  });

  // Section text
  gsap.from(".section_cta .section-text", {
    autoAlpha: 0,
    opacity: 0,
    y: 30,
    duration: 1,
    delay: 0.2,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section_cta",
      start: "top 80%",
    },
  });

  // Section buttons
  gsap.from(".section_cta .section-buttons", {
    autoAlpha: 0,
    opacity: 0,
    y: 35,
    duration: 1,
    delay: 0.4,
    ease: "power2.out",
    scrollTrigger: {
      trigger: ".section_cta",
      start: "top 80%",
    },
  });
}
